var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#66BB6A",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.242 12C20.7136 12 20.2177 12.2552 19.9106 12.6852L16.5293 17.4189L16.4052 17.5928V17.8064V22.2119V22.9462C16.4052 24.9364 18.0186 26.5498 20.0088 26.5498H23.8075C25.3331 26.5498 26.6641 25.514 27.0387 24.0351L27.8472 20.844C28.114 19.7908 28.0275 18.6792 27.6012 17.6799C27.2714 16.907 26.5122 16.4055 25.6719 16.4055H22.8783V13.6362C22.8783 12.7326 22.1457 12 21.242 12ZM12 17.0046C12 16.2682 12.597 15.6712 13.3333 15.6712H14.2028C14.9391 15.6712 15.5361 16.2682 15.5361 17.0046V25.2165C15.5361 25.9529 14.9391 26.5498 14.2028 26.5498H13.3333C12.597 26.5498 12 25.9529 12 25.2165V17.0046Z",
    fill: "#66BB6A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccess);
export default __webpack_public_path__ + "static/media/notificationSuccess.84a828c1d102a041a97a29298097d543.svg";
export { ForwardRef as ReactComponent };